var map = {
	"./AlienRangers.JPG": 4658,
	"./BeastMorphers.JPG": 4833,
	"./DinoCharge.JPG": 2890,
	"./DinoFury.JPG": 8288,
	"./DinoSuperCharge.JPG": 9281,
	"./DinoThunder.JPG": 1719,
	"./InSpace.JPG": 6081,
	"./JungleFury.JPG": 8236,
	"./LightspeedRescue.JPG": 1269,
	"./LostGalaxy.JPG": 3265,
	"./Megaforce.JPG": 9758,
	"./MightyMorphin.JPG": 4066,
	"./MysticForce.JPG": 345,
	"./NinjaSteel.JPG": 5299,
	"./NinjaStorm.JPG": 1176,
	"./OperationOverdrive.JPG": 1759,
	"./R.P.M..JPG": 3680,
	"./S.P.D..JPG": 4101,
	"./Samurai.JPG": 7624,
	"./SuperMegaforce.JPG": 2306,
	"./SuperNinjaSteel.JPG": 4061,
	"./SuperSamurai.JPG": 2394,
	"./TimeForce.JPG": 7586,
	"./Turbo.JPG": 3761,
	"./WildForce.JPG": 2543,
	"./Zeo.JPG": 3599
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9467;